import React, { useState, useEffect, useCallback } from "react";
import Masonry from "react-masonry-css";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useInfiniteScroll } from "react-infinite-scroll-hook";
import * as actions from "../../actions";
import ThumbItem from "../thumbitem";
import { Loader } from "../loader";

import { FiltersState } from "../../reducers/filters";
import { ItemsState } from "../../reducers/items";
// import { useWhyDidYouUpdate } from "../../hooks/useWhyDidYouUpdate";

import { State, Dictionary } from "../../interfaces";

const breakpointColumnsObj = {
  default: 6,
  "1900": 5,
  "1600": 4,
  "1200": 3,
  "992": 2,
  "767": 2,
  "576": 1
};
interface Props {
  labels: Dictionary<string>;
}
const Masonrylist: React.FC<Props> = (props) => {
  // useWhyDidYouUpdate("Masonrylist", props);
  const { labels } = props;
  const filters: FiltersState = useSelector(
    (state: State) => state.filters,
    shallowEqual
  );
  const { typologies, tags, markets } = filters;
  const { byId: typologyById } = typologies.entities;
  const { byId: tagById } = tags.entities;
  const { byId: marketById } = markets.entities;

  const items: ItemsState = useSelector(
    (state: State) => state.items,
    shallowEqual
  );
  const {
    entities,
    page,
    total,
    isLoading,
    selectedItem,
    itemsPerPage
  } = items;

  const { all, byId } = entities;

  const dispatch = useDispatch();

  const [hasNextPage, setHasNextPage] = useState(false);

  useEffect(() => {
    setModalStatus(selectedItem !== null);
  }, [selectedItem]);

  useEffect(() => {
    // controllo che ci siano ancora item da richiedere
    setHasNextPage((page + 1) * itemsPerPage < total);
  }, [itemsPerPage, page, total]);

  const setModalStatus = (open: boolean) => {
    if (document.body) {
      if (open) {
        document.body.classList.add("modal-open");
      } else {
        document.body.classList.remove("modal-open");
      }
    }
  };

  const onGetNextPageForItems = useCallback(
    (page) => dispatch(actions.getNextPageForItems(page)),
    [dispatch]
  );

  const handleOnSelectItem = useCallback(
    (id) => {
      dispatch(actions.selectItem(id));
    },
    [dispatch]
  );

  const handleOnTagClicked = useCallback(
    (tag: string) => dispatch(actions.setTags([tag])),
    [dispatch]
  );

  const onPaginatedSearch = () => {
    // console.log("onPaginatedSearch ");
    // controllo che ci siano ancora item da richiedere
    if (hasNextPage) {
      onGetNextPageForItems(page + 1);
    }
  };

  const infiniteRef = useInfiniteScroll<HTMLDivElement>({
    loading: isLoading,
    // This value is set to "true" for this demo only. You will need to
    // get this value from the API when you request your items.
    hasNextPage,
    onLoadMore: onPaginatedSearch,
    scrollContainer: "window"
  });

  // console.log("masonry ");

  return (
    <div className="masonry-wrapper" ref={infiniteRef}>
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="masonry"
        columnClassName="masonry-column"
      >
        {all.map((itemId, index) => {
          const item = byId[itemId];
          const icon = typologyById[item.typeID[0]].icon;
          item.icon = icon;

          return (
            <ThumbItem
              key={itemId}
              item={item}
              editLabel={labels.edit}
              tagById={tagById}
              marketById={marketById}
              onItemSelect={handleOnSelectItem}
              onTagClicked={handleOnTagClicked}
              downloadLabel={labels.download}
            />
          );
        })}
      </Masonry>
      <Loader isLoading={isLoading} />
      {!isLoading && !hasNextPage && (
        <p style={{ textAlign: "center", marginTop: 20 }}>
          {labels.noMoreItemLabel}
        </p>
      )}
    </div>
  );
};

export default Masonrylist;
